import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import Lottie from 'lottie-react';

import downloadFileBg from '@assets/images/downloadFileBg.svg';
import downloadFileError from '@assets/images/downloadFileError.svg';
import { userExternalDeliveryFileDownloadService } from '@services/public/user/download/external-delivery-file';
import { is200xRange } from '@utils/utilities';
import fileDownloadLottie from '@assets/lottie/fileDownload.json';

type DownloadFileData = {
  downInfo: {
    s3FileList: [{ s3DownUrl: string }];
  } | null;
  userConfigEnv: {
    cssJsVersion: string;
  } | null;
};

const FileDownloadLottie = () => (
  <Box>
    <Lottie animationData={fileDownloadLottie} loop={true} />
  </Box>
);

const ExternalDeliveryFileDownload = () => {
  const { fileId } = useParams();
  const [isDownloadable, setIsDownloadable] = useState(true);
  const [_downloadFileData, setDownloadFileData] = useState<DownloadFileData>({
    downInfo: null,
    userConfigEnv: null,
  });

  function startDownload(url) {
    window.location.href = url;
  }

  const handleDownload = async () => {
    const { response, statusCode, error } =
      await userExternalDeliveryFileDownloadService(fileId);

    if (response?.code === '1' && is200xRange(statusCode)) {
      if (response?.result?.downInfo?.s3FileList.length > 0) {
        response?.result?.downInfo?.s3FileList.forEach((file, index) => {
          setTimeout(() => {
            startDownload(file.s3DownUrl);
          }, index * 1000);
        });
      }
      setDownloadFileData({
        downInfo: response?.result?.downInfo,
        userConfigEnv: response?.result?.userConfigEnv,
      });
    }

    if (
      error ||
      !is200xRange(statusCode) ||
      (response?.code !== '53100' && response?.code !== '1')
    ) {
      setIsDownloadable(false);
    }
  };

  useEffect(() => {
    handleDownload();
  }, []);

  return (
    <Box
      display="flex"
      width="100%"
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundImage: `url(${downloadFileBg})`,
        backgroundPosition: 'bottom',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {!isDownloadable && (
        <Box display="flex" flexDirection="column" gap={5}>
          <Box margin="0 auto">
            <img
              src={downloadFileError}
              alt="download file error"
              width={250}
              height={200}
            />
          </Box>
          <Typography
            fontSize="17px"
            lineHeight="26px"
            fontWeight={400}
            color="var(--base-black)"
          >
            요청한 파일은 다운로드할 수 없습니다.
          </Typography>
        </Box>
      )}
      {isDownloadable && (
        <Box
          display="flex"
          flexDirection="column"
          gap={5}
          maxWidth="302px"
          minWidth="302px"
          alignItems="center"
        >
          <FileDownloadLottie />
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={3}
          >
            <Typography
              fontSize="17px"
              lineHeight="26px"
              fontWeight={400}
              color="var(--base-black)"
              textAlign="center"
            >
              파일이 다운로드 중입니다. 완료까지 잠시만 기다려주세요.
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ExternalDeliveryFileDownload;
